/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Revocation details
 * @export
 * @interface RevokeTenantRelationshipRequest
 */
export interface RevokeTenantRelationshipRequest {
    /**
     * ID of the relationship to revoke
     * @type {string}
     * @memberof RevokeTenantRelationshipRequest
     */
    relationshipId: string;
    /**
     * Reason for revoking the relationship
     * @type {string}
     * @memberof RevokeTenantRelationshipRequest
     */
    revocationReason: string;
}

/**
 * Check if a given object implements the RevokeTenantRelationshipRequest interface.
 */
export function instanceOfRevokeTenantRelationshipRequest(value: object): value is RevokeTenantRelationshipRequest {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('revocationReason' in value) || value['revocationReason'] === undefined) return false;
    return true;
}

export function RevokeTenantRelationshipRequestFromJSON(json: any): RevokeTenantRelationshipRequest {
    return RevokeTenantRelationshipRequestFromJSONTyped(json, false);
}

export function RevokeTenantRelationshipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevokeTenantRelationshipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'revocationReason': json['revocationReason'],
    };
}

export function RevokeTenantRelationshipRequestToJSON(json: any): RevokeTenantRelationshipRequest {
    return RevokeTenantRelationshipRequestToJSONTyped(json, false);
}

export function RevokeTenantRelationshipRequestToJSONTyped(value?: RevokeTenantRelationshipRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'revocationReason': value['revocationReason'],
    };
}

